import React, { useState, useEffect, useRef } from "react";
import {
  FaAddressBook,
  FaAward,
  FaClock,
  FaEnvelope,
  FaMobile,
  FaMoneyBillWave,
  FaSearchLocation,
} from "react-icons/fa";
import Switch from "react-switch";
import { backendApi,backendApiForInterviewQtn } from "../../../api/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaLocationDot } from "react-icons/fa6";
import { MdViewTimeline } from "react-icons/md";
import { FiMenu } from "react-icons/fi";
import "./Dropdown.css";
import { useSelector } from "../../../components/hooks/hooks";
import { FaPencil } from "react-icons/fa6";
import { FiSend } from "react-icons/fi";
// import startInterviewPopup from "./startInterviewPopup"
export default function ShortlistTable({
  candidates,
  formatDateToCustomFormat,
  goToEditPage,
  candidateInterview,
  jobOpeningId,
  getShortList,
  getHiredList,
  getArchivedList,
  OnholdList,
  RejectList,
  RecruitList,
  StatusValues,
  userList,
  is_active
}) {
  console.log(userList, "ss");

  const [showDropIndex, setShowDropIndex] = useState(null);
  const [showPopupStatus, setshowPopupStatus] = useState(false);
  const [ChangeStatusPopUp, setChangeStatusPopUp] = useState(false);

  const [selectedStatus, setSelectedStatus] = useState("");
  const [Remarks, setRemarks] = useState("");
  const [toggleState, setToggleState] = useState(0);
  const [CandidateID, setCandidateID] = useState("");

  const [chatPlayFlag, setChatPlayFlag] = useState(false)
  const [questionData, setQuestionData] = useState([]);
  const [answer, setAnswer] = useState('');
  const [summary, setSummary] = useState('');
  const [rating, setRating] = useState('');
  const [instructionForAi, setInstructionForAi] = useState('');
  const [error, setError] = useState(null);
  const [candidateIDforchatPlay, setCandidateIDforchatPlay] = useState("");

  const { HrmsFlag } = useSelector((state) => state.login);
  console.log(HrmsFlag, "userdata in shortData");
  const popupRef = useRef(null);
  const refDrops = useRef([]);

  useEffect(() => {
    if (showDropIndex !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropIndex]);

  const handleClickOutside = (event) => {
    if (refDrops.current.every(ref => ref && !ref.contains(event.target))) {
      setShowDropIndex(null);
    }
  };

  const toggleDropdown = (index) => {
    setShowDropIndex(showDropIndex === index ? null : index);
  };
  const CancelPopUp = () => {
    setshowPopupStatus(false);
    setSelectedStatus("");
    setRemarks("");
    setToggleState(0)
  };
  const handleStatusEdit = (event) => {
    setSelectedStatus(event.target.value);
  };
  const handleToggle = (checked) => {
    setToggleState(checked ? 1 : 0);
  };
  const CandidateStatusEdit = (id) => {
    setshowPopupStatus(true);
    setCandidateID(id)
  };


  const saveCandidateStatus = () => {
    if (selectedStatus === "") {
      toast.warn("Please select a status", { containerId: "Z" });
      return false;
    }
    var req = {
      functionName: "updateStatusCandiateShortList",
      sec_user_id: localStorage.getItem("userId"),
      candidate_id: CandidateID,
      job_opening_id: jobOpeningId,
      remarks: Remarks,
      category_type: selectedStatus,
      move_to_hrms: toggleState
    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        toast.success("Status Updated Succesfully", { containerId: "Z" });
        setshowPopupStatus(false)
        setSelectedStatus("");
        setRemarks("");
        setToggleState(0)
        getShortList();
        getHiredList();
        getArchivedList();
        OnholdList();
        RejectList();
        RecruitList();
      } else {
        console.error("Error");
        toast.error("Error", { containerId: "Z" });
        return false;
      }
    });
  };
  const [SelectedStatusData, setSelectedStatusData] = useState("")
  const [SelectedStatusId, setSelectedStatusId] = useState(null);

  const StatusPopUp = (id) => {
    console.log(id, "id of candidate");
    setChangeStatusPopUp(true)
    setCandidateID(id.candidate_id)
    const currentStatusName = getStatusName(id.rec_status_id);
    setSelectedStatusData(currentStatusName);
  }

  const handleStatusChange = (event) => {
    setSelectedStatusData(event.target.value);
    const selectedStatus = StatusValues.find(
      (status) => status.status_name === event.target.value
    );
    console.log("Selected selectedStatus:", selectedStatus);
    if (selectedStatus) {
      setSelectedStatusId(selectedStatus.id);
    }
  };
  const ClosePopUpStatus = () => {
    setChangeStatusPopUp(false)
  }



  //UPDATE CANDIDATE STATUS
  const UpdateCandidateStatus = () => {
    if (SelectedStatusData === "") {
      toast.warn("Please select a status", { containerId: "Z" });
      return false;
    }
    var req = {
      functionName: "changeStatusShortList",
      // sec_user_id: localStorage.getItem("userId"),
      candidate_id: CandidateID,
      job_opening_id: jobOpeningId,
      rec_status_id: SelectedStatusId,
      created_by: localStorage.getItem("userId"),

    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        toast.success("Status Updated Succesfully", { containerId: "Z" });
        setChangeStatusPopUp(false)
        setSelectedStatusData("");
        getShortList();
        getHiredList();
        getArchivedList();
        OnholdList();
        RejectList();
        RecruitList();
      } else {
        console.error("Error");
        toast.error("Error", { containerId: "Z" });
        return false;
      }
    });
  };
  const getStatusName = (rec_status_id) => {
    const matchingStatus = StatusValues.find(
      (status) => status.id === rec_status_id
    );
    return matchingStatus ? matchingStatus.status_name : "Status not found";
  };

  const currentUserId = localStorage.getItem('userId');
  const getUserRole = (userId) => {
    const user = userList.find(user => user.id === parseInt(userId, 10));
    return user ? user.role_name : null;
  };
  const currentUserRole = getUserRole(currentUserId);
  function getStatusColor(recStatusId) {
    const statusColors = {
      2: 'green',
      1: 'orange',
      4: 'red',
    };
    return statusColors[recStatusId] || 'gray';
  }
  const getQuestion =async (id) =>{
    const postData = {
        "functionName": "getQuestion",
        "candidateId": id
    }
    try {
      // setLoading(true); // Show loading spinner
      const response = await backendApiForInterviewQtn(postData); // Fetch data
      console.log("dataaaaaaaaaaaaaaaaaaaaaaaaaaaaa",response)
     if(response.statusCode === 500){
      setChatPlayFlag(true)
      setError(response.message)
     }else{
      setChatPlayFlag(true)
      setInstructionForAi(response.result)
      aiConversation(response.result)
      
     }
      //  setQuestionData([{ "role": "assistant", "content": response.data.data.result }]); // Update question data
           
    } catch (err) {
      // setError("Error fetching questions"); // Show error message
      console.error(err);
    } finally {
      // setLoading(false); // Hide loading spinner
    }
  }
  const aiConversation =  async(instruction) => {
    const postData = {
     "functionName": "aiChat",
     "conversationHistory": [
         {
             "role": "system",
             "content": instruction
         }
     ]
   }
   try {
     // setLoading(true); // Show loading spinner
     const response = await backendApiForInterviewQtn(postData); // Fetch data
     console.log("dataaaaaaaaaaaaaaaaaaaaaaaaaaaaa11111111111",response)
    
      setQuestionData([{ "role": "assistant", "content": response.result }]); // Update question data
          
   } catch (err) {
     // setError("Error fetching questions"); // Show error message
     console.error(err);
   } finally {
     // setLoading(false); // Hide loading spinner
   }
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Submit the answer to the backend
    if (answer.trim() === '') {
        // setSubmitError('Answer cannot be empty');
        return;
    }
    const updatedConversation = [
        ...questionData,
        { role: "user", content: answer },
    ];
    let newMessage = { role: "user", content: answer }
    setQuestionData((prevMessages) => [...prevMessages, newMessage]);
    setAnswer(""); // Clear input field

    let conversationHistory = [
        {
            "role": "system",
            "content": instructionForAi
        },
        ...updatedConversation,
    ]
    const postData = {
        "functionName": "aiChat",
        "conversationHistory": conversationHistory
    }
    const response = await backendApiForInterviewQtn(postData);
    console.log("ressssssssssssssssp", response)
    if (response.statusCode === 200) {
        console.log("success.......................", response)
      //  setQuestionData((prevMessages) => [...prevMessages, { "role": "assistant", "content": response.data.data.result }]);

      if (response.result.includes("{S}") && response.result.includes("{R}")) {
        const sContent = response.result.split('{S}')[1].split('{R}')[0].trim();
        const rContent = response.result.split('{R}')[1].trim();
        const content = response.result.split('{S}')[0].trim()
        setSummary(sContent)
        setRating(rContent)
        const postData = {
          "functionName": "saveRatingAndSummary",
          "summary": sContent,
          "rating" : rContent,
          "candidateId" : candidateIDforchatPlay
        }
        const response1 = await backendApiForInterviewQtn(postData);
        console.log("ressssssssssssssssp", response1)
        console.log("kkkkkkkkkkkkkkkkkk",content)
        console.log("summary",sContent)
        console.log("rating",rContent)
        setQuestionData((prevMessages) => {
            // console.log("Previous messages:", prevMessages);
            // console.log("New message:", response.data.data.result);
            return [...prevMessages, { role: "assistant", content: "Thank You! We will reach out shortly if you are shortlisted." }];
        });
    }  else{  

        setQuestionData((prevMessages) => {
            console.log("Previous messages:", prevMessages);
            console.log("New message:", response.result);
            return [...prevMessages, { role: "assistant", content: response.result }];
        });
    }
    }
};


const startInterview =  (id) =>{
  setCandidateIDforchatPlay(id)
  getQuestion(id)
 
}
const closepopupinterview = () => {
  setChatPlayFlag(false)
}
  return (
    <div className="table-scroll table-responsive">
      <ToastContainer
        enableMultiContainer
        containerId={"Z"}
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {candidates.length > 0 ? (
        <table className="table">
          <thead style={{ height: "30px" }}>
            <tr>
              <th style={{ width: '2%', minWidth: '20px' }}>#</th>
              <th style={{ width: '23%', minWidth: '230px' }}>Candidate Details</th>
              <th style={{ width: '21%', minWidth: '210px' }}>Skill Set</th>
              <th style={{ width: '23%', minWidth: '230px' }}>Experience</th>
              <th style={{ width: '19%', minWidth: '190px' }}>Status</th>
              <th style={{ width: '13%', minWidth: '120px' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {candidates.map((candidateData, index) => (
              <tr key={candidateData.candidate_id}>
                <td aria-label="Lead Summary">{index + 1}</td>
                <td aria-label="Lead Summary">
                  <p className="schedule-td-head">{candidateData.full_name}</p>
                  <div className="mb-2">
                    <span className="label-text"><FaAddressBook title="address" size={12} /> </span>
                    <span className="font-Medium"> {candidateData.address || "NA"}</span>
                  </div>
                  <div className="mb-2">
                    <span className="label-text"><FaEnvelope title="email" size={12} /> </span>
                    <span className="font-Medium"> {candidateData.email_id || "NA"}</span>
                  </div>
                  <div className="mb-2">
                    <span className="label-text"><FaMobile title="Contact No:" size={12} /> </span>
                    <span className="font-Medium"> {candidateData.mobile_no || "NA"}</span>
                  </div>
                  <div className="mb-2">
                    <span className="label-text"><FaSearchLocation title="location" size={12} /></span>
                    <span className="font-Medium"> {candidateData.location || "NA"}</span>
                  </div>
                  <div className="mb-2">
                    <span className="label-text"><FaClock title="Uploaded On" size={12} /></span>
                    <span className="font-Medium"> {formatDateToCustomFormat(candidateData.candidate_created_date)}</span>
                  </div>
                </td>
                <td aria-label="Skills" style={{ textAlign: "left" }}>
                  {candidateData.candidate_skill_set ? (
                    candidateData.candidate_skill_set.split(",").map((loc, i) => (
                      <span className="skill-span me-1" key={i}>
                        {loc.trim()}
                      </span>
                    ))
                  ) : (
                    <span style={{ fontSize: 12 }}>NA</span>
                  )}
                </td>
                <td>
                  <div className="mb-2">
                    <span className="label-text"><FaAward title="experience" /></span>
                    <span className="font-Medium"> {candidateData.total_experiance}</span>
                  </div>
                  <div className="mb-2">
                    <span className="label-text"><FaMoneyBillWave title="CTC" size={12} /></span>
                    <span className="font-Medium"> {candidateData.ctc || "NA"}</span>
                  </div>
                  <div className="mb-2">
                    <span className="label-text"><MdViewTimeline title="Notice Period" size={12} /></span>
                    <span className="font-Medium"> {candidateData.notice_period || "NA"}</span>
                  </div>
                  <div className="mb-2">
                    <span className="label-text"><FaLocationDot title="Preferred Location" size={12} /></span>
                    <span className="font-Medium"> {candidateData.preferredLocation || "NA"}</span>
                  </div>
                </td>
                <td>
                  {
                    currentUserRole !== "Recruiter" &&
                      currentUserRole !== 'Executive' ? (
                      <div className="d-flex align-items-center gap-3 mb-2">
                        Status:
                        <b
                          style={{
                            color: getStatusColor(candidateData.rec_status_id),
                            padding: '5px',
                            borderRadius: '4px',
                          }}
                        > {getStatusName(candidateData.rec_status_id)}</b>
                        <FaPencil
                          style={{ color: 'red' }}
                          onClick={() => StatusPopUp(candidateData)}
                        />
                      </div>
                    ) : null}

                  <div><span>Updated By {candidateData.rec_status_by}</span></div>
                  <div><span>On {new Date(candidateData.res_status_date).toLocaleDateString()}</span></div>
                  <br></br>
                  <span>
                    <span className="shortlist-name" >ShortListed By</span> {candidateData.shortlisted_by}
                  </span>

                </td>
                <td aria-label="View" style={{ textAlign: "center" }}>
                  <div className="mt-1 position-relative">
                    <FiMenu onClick={() => toggleDropdown(index)} size={24} />
                    <div
                      ref={el => refDrops.current[index] = el}
                      className={`dropdown-card ${showDropIndex === index ? "show" : ""}`}
                    >
                      <ul>
                        <li onClick={() => goToEditPage(candidateData.candidate_id)}>Edit</li>
                        <li onClick={() => startInterview(candidateData.candidate_id)}>Start Interview</li>
                        <li onClick={() => candidateInterview(candidateData.candidate_id)}>Schedule</li>
                        <li onClick={() => CandidateStatusEdit(candidateData.candidate_id)}>Move Position</li>

                      </ul>
                    </div>
                  </div>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <span style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <h4 className="errorMsg">No Candidates shortlisted</h4>
        </span>
      )}

      {showPopupStatus && (
        <div
          className="modal_parent"
          id="deletesprint"
        >
          <div className="module_popup deletePeople">
            <div className="module_innerpopup module_bodypop">
              <div className="module_headdiv">
                <h4 className="popup_head"> Change Status</h4>
              </div>
              <div className="form-row">
                <label htmlFor="" className="form-label">
                  Status <span className="red ml-1">*</span>
                </label>
                <select
                  className="form-control"
                  name="status"
                  value={selectedStatus}
                  onChange={handleStatusEdit}
                >
                  <option value="">-Select-</option>
                  <option value="Archived">Archived</option>
                  <option value="Hired">Selected</option>
                </select>

                <div class="form-group">
                  <label for="" class="form-label">Remarks </label>
                  <textarea type="text" value={Remarks} onChange={(e) => setRemarks(e.target.value)} class="form-control" placeholder="Enter Remarks..." name="Remark"></textarea>
                </div>
              </div>
              <div className="mt-2 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                {HrmsFlag === 1 && selectedStatus === "Hired" && (
                  <div className="d-flex flex-column align-items-start">
                    <small>Move to HRMS</small>
                    <Switch
                      className="switch_case"
                      handleDiameter={16}
                      height={18}
                      width={40}
                      checked={toggleState === 1}
                      onChange={handleToggle}
                    />
                  </div>
                )}
                <div className="d-flex gap-3">
                  <button
                    type="submit"
                    className="btn btn-btn1 btn-btn"
                    onClick={saveCandidateStatus}
                    disabled={is_active === 0}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    className="btn btn-btn2 btn-btn"
                    onClick={() => CancelPopUp()}

                  >
                    Cancel
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}

      {ChangeStatusPopUp && (
        <div
          className="modal_parent"
          id="deletesprint"
        >
          <div className="module_popup deletePeople">
            <div className="module_innerpopup module_bodypop">
              <div className="module_headdiv">
                <h4 className="popup_head"> Change Status</h4>
              </div>
              <div className="form-row">
                <label htmlFor="" className="form-label">
                  Status <span className="red ml-1">*</span>
                </label>
                <select
                  className="form-control"
                  name="status"
                  value={SelectedStatusData}
                  onChange={handleStatusChange}
                >
                  <option value="">-Select-</option>
                  {StatusValues.filter((status) => status.is_default === 1).map((status) => (
                    <option key={status.id} value={status.status_name}>
                      {status.status_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mt-2 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                <div className="d-flex gap-3">
                  <button
                    type="submit"
                    className="btn btn-btn1 btn-btn"
                    onClick={UpdateCandidateStatus}
                    disabled={is_active === 0}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    className="btn btn-btn2 btn-btn"
                    onClick={ClosePopUpStatus}

                  >
                    Cancel
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}
      
      {chatPlayFlag == true &&
        <div className="popup-outer ">
          <div className="popup-inner">
            <div className="popup-header">AI Interview</div>
            <div onClick={closepopupinterview} style={{ cursor: "pointer" }}>x</div>
            <div className="popup-body">
              {console.log("questionnnnnnn", questionData)}
              {questionData.length > 0 ? (
                questionData.map((item, index) => (
                  <div className="listing-outer-div">
                    {item.role === "user" ?
                      <div className="list-sender list-send-receive">{item.content}</div>
                      :
                      <div className="list-receive list-send-receive">{item.content}</div>
                    }
                  </div>
                )))
                :   <div className="listing-outer-div">{error}
                </div>
              }
            </div>
            {((error == null) && (summary == "" && rating == "")) &&
            <div className="popup-footer">
              <div className="position-relative w-100">
                <FiSend
                  style={{ position: 'absolute', right: '8px', bottom: '8px', cursor: 'pointer' }}
                />
                <textarea value={answer}
                  onChange={(e) => setAnswer(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
                  rows={2} className="form-control" style={{ resize: 'none', paddingRight: '30px', border: '1px solid #ddd1px solid rgb(105 97 97)' }}></textarea>
              </div>

            </div>}
          </div>
        </div>}
      {/* <startInterviewPopup  chatPlayFlag={chatPlayFlag} popupRef={popupRef}/> */}
    </div>
    
  );
}
